import toastErrors from './toast-errors'

export const errorCodeToastMap = {
  'FLEET_TASK.ROUTE_OPTIMIZATION_INVALID_BREAK_TIME':
    toastErrors['fleet-task-route-optimization-invalid-break-time'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_START_BREAK_TIME_GREATER_THAN_END_BREAK_TIME':
    toastErrors['fleet-task-route-optimization-start-break-time-greater-than-end-break-time'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_VENDOR_PLATFORM_INVALID_LAT_LNG':
    toastErrors['fleet-task-route-optimization-vendor-platform-invalid-lat-lng'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_LIMIT_REACHED':
    toastErrors['fleet-task-route-optimization-limit-reached'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_EMPTY_ORDER':
    toastErrors['fleet-task-route-optimization-empty-order'],
  'FLEET_TASK.ROUTE_OPTIMIZATION.DELIVERY_ORDER_USER_GROUP_ID.REQUIRED':
    toastErrors['fleet-task-route-optimization-delivery-order-user-group-id-required'],
  'FLEET_TASK.ROUTE_OPTIMIZATION.DELIVERY_ORDER_USER_GROUP_ID.DIFFERENT':
    toastErrors['fleet-task-route-optimization-delivery-order-user-group-id-different'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_VEHICLE_UNASSIGNED':
    toastErrors['fleet-task-route-optimization-vehicle-unassigned'],
  'FLEET_TASK.DELIVERY_ORDER_INVALID_STATUS':
    toastErrors['fleet-task-delivery-order-invalid-status'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_VEHICLE_ALREADY_ASSIGNED':
    toastErrors['fleet-task-route-optimization-vehicle-already-assigned'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_INVALID_STATUS':
    toastErrors['fleet-task-route-optimization-invalid-status'],
  'FLEET_TASK.DELIVERY_ORDER_PRODUCT_CATEGORY_ID.DIFFERENT':
    toastErrors['fleet-task-delivery-order-product-category-id-different'],
  'FLEET_TASK.DELIVERY_ORDER_PRODUCT_CATEGORY.MORE_THAN_ONE':
    toastErrors['fleet-task-delivery-order-product-category-more-than-one'],
  'FLEET_TASK.ROUTE_OPTIMIZATION_INVALID_SINGLE_PICKUP':
    toastErrors['fleet-task-route-optimization-invalid-single-pickup'],
}
